export default {
  id: "schedule-activity",
  name: "Schedule Activity",
  settings: {}
};
